import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { ShieldCheck, ArrowRight } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_2999b2bb-a766-4d2f-9d69-24fdb875566a/artifacts/5zlw12hm_fa-logo.png";

export default function Home() {
  return (
    <div
      className="min-h-screen flex flex-col bg-[#FAFAFA] relative overflow-hidden"
      data-testid="home-page"
    >
      {/* Accent backdrop */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-[#F50E02]/10 blur-3xl" />
        <div className="absolute -bottom-32 -left-32 w-[28rem] h-[28rem] rounded-full bg-[#F50E02]/5 blur-3xl" />
      </div>

      {/* Top bar */}
      <header className="relative z-10 px-6 sm:px-10 py-5 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-black rounded-full p-1.5">
            <img
              src={LOGO_URL}
              alt="Sree LPG Fuel Access"
              className="h-8 w-8 object-contain"
            />
          </div>
          <span className="font-display text-sm font-semibold text-[#0A0A0A]">
            Sree LPG <span className="text-[#F50E02]">Fuel Access</span>
          </span>
        </div>
        <Link to="/admin/login" data-testid="home-admin-link">
          <Button
            className="bg-[#F50E02] hover:bg-[#D80C02] text-white rounded-md h-10 px-5 font-medium"
            data-testid="home-admin-button"
          >
            <ShieldCheck className="h-4 w-4 mr-1.5" />
            Admin
          </Button>
        </Link>
      </header>

      {/* Hero */}
      <main className="relative z-10 flex-1 flex flex-col items-center justify-center text-center px-6 pb-16">
        <p
          className="text-xs font-semibold uppercase tracking-[0.25em] text-[#F50E02] mb-6"
          data-testid="home-eyebrow"
        >
          Fuel Access Platform
        </p>
        <h1
          className="font-display font-extrabold tracking-tight text-[#0A0A0A] text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[1.05] max-w-5xl"
          data-testid="home-title"
        >
          Welcome to{" "}
          <span className="text-[#F50E02]">Sree LPG</span>
        </h1>
        <p
          className="mt-6 text-base sm:text-lg text-[#525252] max-w-2xl"
          data-testid="home-subtitle"
        >
          Secure cylinder tracking, fuel access management, and compliance —
          all in one place.
        </p>

        <div className="mt-10 flex items-center gap-3">
          <Link to="/admin/login" data-testid="home-cta-link">
            <Button
              className="bg-[#F50E02] hover:bg-[#D80C02] text-white rounded-md h-12 px-7 font-medium text-base"
              data-testid="home-cta-button"
            >
              Go to Admin Login
              <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </Link>
        </div>
      </main>

      <footer className="relative z-10 px-6 py-6 text-center">
        <p className="text-xs text-[#A3A3A3]" data-testid="home-copyright">
          © {new Date().getFullYear()} Sree LPG · Fuel Access Panel
        </p>
      </footer>
    </div>
  );
}
